import { baggageRules } from './definitions';

export const allLegsHaveValidBaggageOption = (legs, predicate) =>
  Array.isArray(legs) &&
  legs.every(
    leg =>
      Array.isArray(leg.options) &&
      leg.options.some(option => predicate(option))
  );

// Filtro de clusters según equipaje seleccionado
export const baggageSimpleFilter = (searchResults, baggageSelected) => {
  const predicate = baggageRules[baggageSelected];

  if (!predicate) return [...searchResults];

  return searchResults.filter(cluster =>
    cluster.legs.every(
      leg =>
        Array.isArray(leg.options) &&
        leg.options.some(option => predicate(option))
    )
  );
};
